export default "__VITE_ASSET__CRDgCoYD__"